// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ChargeAuditList } from '@/billing/components/charge-audit-list';
import { AuditDrawer } from '@/components/audit-drawer';
import { SupportErrorBoundary } from '@/components/support-error-boundary';
import { Suspense } from 'react';

interface Props {
  // Nano-id key of the charge whose audit history to render. May be null when
  // the drawer is closed and no charge has been selected yet.
  chargeKey: string | null;
  disclosure: {
    isOpen: boolean;
    open: () => void;
    close: () => void;
  };
}

/**
 * Side drawer that displays the chronological audit log for a single charge.
 * Mirrors the NoteAuditDrawer pattern so the shared AuditDrawer chrome and
 * Suspense fallbacks behave identically.
 */
export function ChargeAuditDrawer(props: Props) {
  return (
    <AuditDrawer
      title="Charge audit log"
      disclosure={props.disclosure}
      auditLog={
        <SupportErrorBoundary message="An error occurred while loading the audit log.">
          <Suspense>
            {props.chargeKey !== null && (
              <ChargeAuditList chargeKey={props.chargeKey} />
            )}
          </Suspense>
        </SupportErrorBoundary>
      }
    />
  );
}
